import { render, staticRenderFns } from "./IdeasListWidget.vue?vue&type=template&id=0efa3fb1"
import script from "./IdeasListWidget.vue?vue&type=script&lang=js"
export * from "./IdeasListWidget.vue?vue&type=script&lang=js"
import style0 from "./IdeasListWidget.vue?vue&type=style&index=0&id=0efa3fb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports